/**
 * @file: urlWithHashStripped.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const urlWithHashStripped = (url: string) => {
  const idx = url.indexOf('#');
  return idx >= 0 ? url.substring(0, idx) : url;
};

export const urlWithHashStrippedMaybe = (url: string | null | undefined) => {
  if (url == null) return undefined;
  const idx = url.indexOf('#');
  return idx >= 0 ? url.substring(0, idx) : url;
};
